export const SOCIAL_SOURCES = [
  'instagram',
  'tiktok',
  'youtube',
  'facebook',
  'linkedin',
  'twitter',
  'x',
  'threads',
  'telegram',
  'whatsapp',
  'reddit',
  'pinterest',
  'snapchat',
] as const;
